export const DELETE_CUSTOM_CHART_MOCK = {
    "data":{
        "deleteCustomChart": "0-custom-chart"
    }
}